import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const generateMemberEmployeeIds = (count) =>
  axios.post(
    `${BASE_URL}/members/employee-id-generator/generate`,
    { count },
    { headers: getAuthHeaders() }
  );

export const getMemberEmployeeIdGenerationHistory = (params) =>
  axios.get(`${BASE_URL}/members/employee-id-generator/history`, {
    params,
    headers: getAuthHeaders(),
  });

export const getMemberEmployeeIdBatch = (batchId, params) =>
  axios.get(`${BASE_URL}/members/employee-id-generator/batches/${encodeURIComponent(batchId)}`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportMemberEmployeeIdBatch = (batchId) =>
  axios.get(
    `${BASE_URL}/members/employee-id-generator/batches/${encodeURIComponent(batchId)}/export`,
    {
      headers: getAuthHeaders(),
      responseType: "blob",
    }
  );
